var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 27,
        /* Optional */
        loadProductFirst: false
    }
};
// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sold_out + '</span>',
    'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
    'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',

    // Grid Template
    'productGridItemHtml':  '<div class="grid__item small--one-whole medium--one-half medium-up--one-half large-up--one-third">' +
                              '<div class="grid-view-item" {{tag_colour}}>' +
                                '<meta itemprop="position" content="{{forloop_index}}">' +
                                '<div class="grid-view-item__image">' +
                                  '<a href="{{itemUrl}}" class="grid-view-item__link grid-view-item__image-container">' +
                                      '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" onload="imgLoaded(this)">' +
                                      '<span class="product-price__sold-out subheading">{{itemSoldOutLabel}}</span>' +
                                  '</a>' +
                                  '{{tag_label}}' +
                                  '{{itemPrice}}' +
                                '</div>' +

                                '<a class="grid-view-item__header" href="{{itemUrl}}">' +
                                  '<div {{tag_bgimg}} >' +
                                    '<span class="grid-view-item__title">{{itemTitle}}</span>' +
                                    '<span class="grid-view-item__subtitle">{{itemSubtitle}}</span>' +
                                  '</div>' +
                                '</a>' +

                                '<div class="grid-view-item__meta {{subscriptionItemClass}}">' +
                                  '{{tag_flavour_notes}}' +
                                  '{{tag_tagline}}' +
                                  '{{item_details}}' +
                                  '{{item_description}}' +

                                  '<div class="grid-view-item__actions">' +
                                    '<div class="grid-view-item__actions-wrapper {{itemQuickaddClass}}">' +
                                      '<span class="grid-view-item__actions-title">' + bcSfFilterConfig.custom.would_you_like_to + '</span>' +
                                      '<a href="{{itemUrl}}" itemprop="item">' +
                                        '<div class="btn">' + bcSfFilterConfig.custom.learn_more + '</div>' +
                                      '</a>' +
                                      '{{actionSeparator}}' +
                                      '{{quickAddBtn}}' +
                                    '</div>' +
                                  '</div>' +

                                '</div>' +

                                '{{quickAddForm}}' +

                              '</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}"><svg width="10px" height="18px" viewBox="0 0 10 18" class="icon icon-arrow-left" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs></defs><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="icon/back" transform="translate(-7.000000, -3.000000)" stroke="#2C104C" stroke-width="2"><g id="ic_back"><g id="back" transform="translate(8.000000, 4.000000)"><path d="M8,0 L0,8" id="Line"></path><path d="M0,8 L8,16" id="Line"></path></g></g></g></g></svg></a></li>',
    'previousDisabledHtml': '<li class="disabled"><span><svg width="10px" height="18px" viewBox="0 0 10 18" class="icon icon-arrow-left" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs></defs><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="icon/back" transform="translate(-7.000000, -3.000000)" stroke="#2C104C" stroke-width="2"><g id="ic_back"><g id="back" transform="translate(8.000000, 4.000000)"><path d="M8,0 L0,8" id="Line"></path><path d="M0,8 L8,16" id="Line"></path></g></g></g></g></svg></span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}"><svg width="10px" height="18px" viewBox="0 0 10 18" class="icon icon-arrow-right" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs></defs><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="icon/forward" transform="translate(-7.000000, -3.000000)" stroke="#2C104C" stroke-width="2"><g id="ic_forward" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "><g id="ic_back"><g id="back" transform="translate(8.000000, 4.000000)"><path d="M8,0 L0,8" id="Line"></path><path d="M0,8 L8,16" id="Line"></path></g></g></g></g></g></svg></a></li>',
    'nextDisabledHtml': '<li class="disabled"><span><svg width="10px" height="18px" viewBox="0 0 10 18" class="icon icon-arrow-right" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs></defs><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="icon/forward" transform="translate(-7.000000, -3.000000)" stroke="#2C104C" stroke-width="2"><g id="ic_forward" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "><g id="ic_back"><g id="back" transform="translate(8.000000, 4.000000)"><path d="M8,0 L0,8" id="Line"></path><path d="M0,8 L8,16" id="Line"></path></g></g></g></g></g></svg></span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label><select class="bc-sf-filter-filter-dropdown" js-target="sorting-dropdown">{{sortingItems}}</select>',
    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown" js-target="sorting-dropdown">{{showLimitItems}}</select>',
    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};

/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {

  /*** Prepare data ***/
  var isCoffeeClub = false,
  isRSUB = false,
  isRPO = false,
  soldOut = !data.available,
  onSale = data.compare_at_price_min > data.price_min,
  tag_coffee_club = '',
  tag_label = '',
  tag_flavour_notes = '',
  tag_tagline = '',
  tag_quality_score = '',
  tag_roast = '',
  tag_colour = '',
  tag_bgimg = '',
  roast_class_1 = '',
  roast_class_2 = '',
  roast_class_3 = '';

  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
      for (var i = 0; i < data['variants'].length; i++) {
          if (data['variants'][i].available) {
              firstVariant = data['variants'][i];
              break;
          }
      }
  }

  data.tags.map(function(i) {
      if (i.includes('coffee_club')) {
          isCoffeeClub = true
          return tag_coffee_club = data.description;
      } else if (i.includes('label:')) {
          return tag_label = i.replace('label: ','');
      } else if (i.includes('PREORDER') || i.includes('pre-order')) {
        return isRPO = true; 
      } else if (i.includes('flavor_notes:')) {
        return tag_flavour_notes = i.replace('flavor_notes: ','').replace(/\|/g, ', ')
      } else if (i.includes('flavour_notes:')) {
        return tag_flavour_notes = i.replace('flavour_notes: ','').replace(/\|/g, ', ')
      } else if (i.includes('tagline:')) {
        return tag_tagline = i.replace('tagline: ','');
      } else if (i.includes('quality_score:')) {
        return tag_quality_score = i.replace('quality_score: ','');
      } else if (i.includes('roast:')) {
        return tag_roast = i.replace('roast: ','');
      } else if (i.includes('colour:')) {
        return tag_colour = i.replace('colour: ','');
      } else if (i.includes('bgimg:')) {
        return tag_bgimg = i.replace('bgimg: ','');
      }
  });
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  // Add Thumbnail
  var images = Object.keys(data.images).map(function (key) { return data.images[key]; });

  if (images.length <= 1) {
      itemHtml = itemHtml.replace('<img class="hidden" src="{{itemAltThumbUrl}}" alt="{{itemTitle}}">', '');
  }

  if (images.length > 1) {
      itemHtml = itemHtml.replace('no-reveal', 'reveal');
  }

  var thumbUrl = images.length > 0 ? images[0].src : bcSfFilterConfig.general.no_image_url;
  var thumbUrl_min = thumbUrl.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, thumbUrl_min);

  var thumbAltUrl = images.length > 1 ? images[1].src : bcSfFilterConfig.general.no_image_url;
  var thumbAltUrl_min = thumbAltUrl.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');
  itemHtml = itemHtml.replace(/{{itemAltThumbUrl}}/g, thumbAltUrl_min);

  // Add Price
  var itemPriceHtml = '';
  if (data.title != '')  {
      itemPriceHtml += '<div class="grid-view-item__price">';
      if (onSale) {
          //itemPriceHtml += '<s class="product-price__price money">' + this.formatMoney(data.compare_at_price_min).replace('.00', '') + '</s> ';
          // Ramnati Note: Changed on sale behaviour as suggested clickup - #8693bu6ej 
          itemPriceHtml += '<span class="product-price__price money ">' + this.formatMoney(data.price_min).replace('.00', '') + '</span> ';
      }
      else {
          itemPriceHtml += this.formatMoney(data.price_min).replace('.00', '');
      }
      itemPriceHtml += '</div>';
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add soldOut Label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add onSale Label
  var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title.split(', ')[0]);
  itemHtml = itemHtml.replace(/{{itemType}}/g, data.product_type.toLowerCase().replace(/ /g, '-'));

  if (data.product_type.toLowerCase().replace(/ /g, '-') == "coffee-subscription"){
    isRSUB = true; 
  }

  if (data.title.split(', ')[1] == undefined) {
    itemHtml = itemHtml.replace(/{{itemSubtitle}}/g, '');
    var product_subtitle = '';
  } else {
    itemHtml = itemHtml.replace(/{{itemSubtitle}}/g, data.title.split(', ')[1]);
    var product_subtitle = data.title.split(', ')[1];
  }

  //For loop index
  itemHtml = itemHtml.replace(/{{forloop_index}}/g, index);


  // Add Tags
  if (tag_coffee_club == '') {
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  } else {
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, tag_coffee_club);
  }

  if (tag_label == '') {
    itemHtml = itemHtml.replace(/{{tag_label}}/g, '');
  } else {
    itemHtml = itemHtml.replace(/{{tag_label}}/g, '<div class="grid-view-item__label"><span>' + tag_label + '</span></div>');
  }

  if (tag_flavour_notes == '') {
    itemHtml = itemHtml.replace(/{{tag_flavour_notes}}/g, '');
  } else {
    itemHtml = itemHtml.replace(/{{tag_flavour_notes}}/g,
      '<div class="grid-view-item__notes">' +
        '<span class="grid-view-item__notes-title">' + bcSfFilterConfig.custom.notes_of + '</span>' +
        '<span class="grid-view-item__notes-value">' + tag_flavour_notes + '</span>' +
      '</div>');
  }

  if (tag_tagline == '') {
    itemHtml = itemHtml.replace(/{{tag_tagline}}/g, '');
  } else {
    itemHtml = itemHtml.replace(/{{tag_tagline}}/g, '<div class="grid-view-item__tagline">' + tag_tagline + '</div>');
  }

  if (tag_roast == 'Light' || tag_roast == 'Medium' || tag_roast == 'Dark') {
    var roast_class_1 = 'grid-view-item__roast-icon--active';
  }
  if (tag_roast == 'Medium' || tag_roast == 'Dark') {
    var roast_class_2 = 'grid-view-item__roast-icon--active';
  }
  if (tag_roast == 'Dark' || tag_roast == '0') {
    var roast_class_3 = 'grid-view-item__roast-icon--active';
  }

  if (tag_quality_score != '' && tag_roast != '') {
    itemHtml = itemHtml.replace(/{{item_details}}/g,
      '<div class="grid-view-item__details">' +
        '<div class="grid-view-item__detail">' +
          '<span class="grid-view-item__detail-title">' + bcSfFilterConfig.custom.quality_score + ':</span>' +
          '<span class="grid-view-item__detail-value grid-view-item__detail-value--quality-score">' + tag_quality_score + '</span>' +
        '</div>' +
        '<div class="grid-view-item__detail">' +
          '<span class="grid-view-item__detail-title">' + bcSfFilterConfig.custom.roast + ':</span>' +
          '<span class="grid-view-item__detail-value">' +
            '<span class="grid-view-item__roast-icon ' + roast_class_1 + '"></span>' +
            '<span class="grid-view-item__roast-icon ' + roast_class_2 + '"></span>' +
            '<span class="grid-view-item__roast-icon ' + roast_class_3 + '"></span>' +
          '</span>' +
        '</div>' +
      '</div>');
  } else {
    itemHtml = itemHtml.replace(/{{item_details}}/g, '');
  }

  if (tag_flavour_notes == '' && tag_tagline == '' && tag_quality_score == '' && tag_roast == '' && !isCoffeeClub) {
    itemHtml = itemHtml.replace(/{{item_description}}/g, '<p class="grid-view-item__description">' + data.description.split('###')[0].replace(/(<([^>]+)>)/ig,"").split('http://')[0] + '</p>');
  } else {
    itemHtml = itemHtml.replace(/{{item_description}}/g, '');
  }

  if (tag_colour != '') {
    itemHtml = itemHtml.replace(/{{tag_colour}}/g, 'style="color: ' + tag_colour + '"');
  } else {
    itemHtml = itemHtml.replace(/{{tag_colour}}/g, '');
  }
  
  if (tag_bgimg != '') {

    itemHtml = itemHtml.replace(/{{tag_bgimg}}/g, 'class="cXmas '+tag_bgimg.split(":")[1]+'"');
  } else {
    itemHtml = itemHtml.replace(/{{tag_bgimg}}/g, '');
  }


  // Product quickadd class
  if ((data['variants'].length > 1) && (data.product_type == 'Equipment')) {
    itemHtml = itemHtml.replace(/{{itemQuickaddClass}}/g, 'grid-view-item__actions-wrapper--single-button');
  } else {
    itemHtml = itemHtml.replace(/{{itemQuickaddClass}}/g, '');
  }

  // Product quickadd button
  if ((data['variants'].length > 1)|| isRPO) {
    if (data.product_type == 'Equipment') {
      itemHtml = itemHtml.replace(/{{actionSeparator}}/g, '');
      itemHtml = itemHtml.replace(/{{quickAddBtn}}/g, '');
      itemHtml = itemHtml.replace(/{{subscriptionItemClass}}/g, '');

    } else if ((data.product_type == 'Subscription') || isRSUB || isRPO ) {
      
      itemHtml = itemHtml.replace(/{{actionSeparator}}/g, '');
      itemHtml = itemHtml.replace(/{{quickAddBtn}}/g, '');
      itemHtml = itemHtml.replace(/{{subscriptionItemClass}}/g, '')


    } else {
      itemHtml = itemHtml.replace(/{{actionSeparator}}/g, '<span class="grid-view-item__actions-separator">' + bcSfFilterConfig.custom.card_actions_separator + '</span>');
      itemHtml = itemHtml.replace(/{{quickAddBtn}}/g, '<div class="btn btn--hollow" open-quick-add data-pos-id="' + index + '">' +  bcSfFilterConfig.custom.quick_add + '</div>');
      itemHtml = itemHtml.replace(/{{subscriptionItemClass}}/g, '');
    }

  } else {
    if(isCoffeeClub) {
      itemHtml = itemHtml.replace(/{{actionSeparator}}/g, '');
      itemHtml = itemHtml.replace(/{{quickAddBtn}}/g, '');
      itemHtml = itemHtml.replace(/{{subscriptionItemClass}}/g, 'subscription_meta');
    } else {
      itemHtml = itemHtml.replace(/{{actionSeparator}}/g, '<span class="grid-view-item__actions-separator">' + bcSfFilterConfig.custom.card_actions_separator + '</span>')
      itemHtml = itemHtml.replace(/{{quickAddBtn}}/g,
      '<form method="post" action="/cart/add" id="product_form_' + data.id + '" accept-charset="UTF-8" class="product-form product-form-' + data.id + '" enctype="multipart/form-data" data-quantity="1" data-section-id="' + data.id + '">' +
        '<input type="hidden" name="form_type" value="product">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="id" value="' + firstVariant.id + '" />' +
        '<input quick-add-submit type="submit" name="add" class="btn btn--hollow" data-product-id="' + data.id + '" value="' + bcSfFilterConfig.custom.quick_add + '" />' +
      '</form>');
      itemHtml = itemHtml.replace(/{{subscriptionItemClass}}/g, '');
    }
  }

  // build swatches

  var index_form = 1;

  var data_options = data.options_with_values.map(function(i) {
    var productFormItem = '';
    var product_options = data.options.toString()

    if (data.options.length != 1 && data['variants'][0].title != 'Default Title') {

      if (product_options.includes('grind_style') || product_options.includes('grind_type') || product_options.includes('beans_or_grind')) {
        var option_handle = i.name.toLowerCase().replace(/ /g, '-').replace(/_/g, '-');
        var option_name = i.label;
        var index_number = 0;
        var index_loop_option = index_form++;

        var variantOption = i.values.map(function(item) {
          return item.title
        })

        var variantOptionTemplate = variantOption.map(function(value) {

          var variantPrice = data.variants.map(function(item) {
            if(item.title.split(' / ')[0] == value) {
              var price = item.price;
            } else {
              var price = '';
            }
            return price;
          })

          var variantValue = data.variants.map(function(item) {
            if(item.title.split(' / ')[0] == value) {
              var v = item.title.split(' / ')[1]
            } else {
              var v = '';
            }
            return v;
          })

          var index_loop = index_number++;
          var priceSet = new Set(variantPrice)
          var priceArray = Number(Array.from(priceSet).join(''))
          var price = bcFormatMoney(priceArray).replace('.00', '')
          var valueCombinationSet = new Set(variantValue)
          var valueCombination = Array.from(valueCombinationSet).filter(Boolean).join(',').toLowerCase().replace(/ /g, '-')

          if (valueCombination != '') {
            data_option_values = '" data-option-values="' + valueCombination;
          } else {
            data_option_values = ''
          }

          if (index_loop == 0) {
           var checked = 'checked';
          } else {
            var checked = '';
          }

          if (option_handle == 'size') {
            var option_html = '<span class="single-option__price">' + price + '</span>'
          } else {
            var value_icon_url = '//cdn.shopify.com/s/files/1/0060/6230/9494/files/style-' + value.toLowerCase().replace(/ /g, '-') + '.png';
            var option_html = '<img src="' + value_icon_url + '" alt="' + value + '" />'
          }

          var template =
          '<label for="SingleOptionSelector_' + option_handle + '_' + index_loop + '--' + (index - 1) + '-' + data.id + '" class="single-option" data-option="' + option_handle + '" data-index="option' + index_loop_option + '">' +
            '<input type="radio" value="' + value + '" data-value-handle="' + value.toLowerCase().replace(' ','-') + '"' + checked + ' name="' + option_handle + '" class="single-option-selector single-option-selector-' + data.id + ' product-form__input" id="SingleOptionSelector_' + option_handle + '_' + index_loop + '--' + (index - 1) + '-' + data.id + '" data-index="option' + index_loop_option + data_option_values + '"/>' +
            option_html +
            '<span class="single-option__label">' + value + '</span>' +
          '</label>'

          return template
        })

        var productFormItem =  '<div class="product-form__item selector-wrapper js product-form__item"><label class="label" for="SingleOptionSelector-' + (index - 1) + '--' + (index - 1) + '-' + data.id + '">' + option_name + '</label>' + variantOptionTemplate.join('') + '</div>'
      }
    }
    return productFormItem;
  });

  // Build disabled attr + addToCart text

  if (data.selected_or_first_available_variant.available != true) {
    var disabledAttr = 'disabled="disabled"';
    var addToCartText = bcSfFilterConfig.custom.sold_out;
  } else {
    var disabledAttr = '';
    var addToCartText = bcSfFilterConfig.custom.add_to_cart;
  }

  // Build option select

  var selectOptions = data.variants.map(function(variant) {

    if (variant.available == true) {

      if (variant.id == data.selected_or_first_available_variant.id) {
        var selected = 'selected="selected"'
      } else {
        var selected = ''
      }
      var option = '<option ' + selected + ' value="' + variant.id + '">' + variant.title +  '</option>'

    } else {

      var option = '<option disabled="disabled">' + variant.title +  ' - ' + bcSfFilterConfig.custom.sold_out; + '</option>'
    }

    return option;
  })

  var quickaddSelect = '<select name="id" id="ProductSelect-' + data.id + '" data-section="' + data.id + '" class="product-form__variants no-js">' + selectOptions + '</select>'

  // Build quantity

  var quickaddQty =
  '<div class="product-form__quantity item-quantity">' +
    '<div class="item-quantity--input-wrapper">' +
      '<select name="quantity">' +
        '<option value="1">1</option>' +
        '<option value="2">2</option>' +
        '<option value="3">3</option>' +
        '<option value="4">4</option>' +
        '<option value="5">5</option>' +
      '</select>' +
    '</div>' +
  '</div>'

  // Build tooltip

  // if (data.product_type == 'Coffee') {
  //   var quickaddTooltip =
  //     '<div class="product-form__badge">' +
  //       '<img src="//cdn.shopify.com/s/files/1/0060/6230/9494/t/10/assets/union-badge-2x.png" data-tooltip data-tooltip-content="Our direct trade coffee from Brazil is grown on small-producer farms, all neighbours’ of Fazenda Ambiental Fortaleza" />' +
  //     '</div>'
  // }

  // Build form
  if (data['variants'].length > 1) {
    itemHtml = itemHtml.replace(/{{quickAddForm}}/g,
    '<div id="ProductSection-' + data.id + '" data-section-id="' + data.id + '" data-section-type="product">' +
      '<form method="post" action="/cart/add" data-pos-id="'+ index + '" id="product_form_' + data.id + '" accept-charset="UTF-8" class="product-form--quickadd product-form product-form-' + data.id + '" enctype="multipart/form-data" data-id="' + index + '" data-quantity="1" data-section-id="' + data.id + '">' +
        '<div class="quickadd__header">' +
          '<div class="quickadd__title">' + data.title.split(', ')[0] + '</div>' +
          '<div class="quickadd__subtitle">' + product_subtitle + '</div>' +
        '</div>' +

        '<div class="quickadd__body">' +
          '<span class="quickadd__close" close-quick-add data-pos-id="' + index + '">' + bcSfFilterConfig.custom.icon_close + '</span>' +
          data_options.join('') +
          quickaddSelect +
          '<div class="product-form__item--submit">' +
            '<button quick-add-submit type="submit" name="add" data-product-id="' + data.id + '" id="AddToCart-' + data.id + '" ' + disabledAttr + ' class="btn product-form__cart-submit">' +
                '<span id="AddToCartText-' + data.id + '">' + addToCartText + '</span>' +
            '</button>' +
            quickaddQty +
            '<div class="product-single__delivery"></div>' +
          '</div>' +
        '</div>' +
      '</form>' +
    '</div>' +
    '<script type="application/json" id="ProductJson-' + data.id + '">' +
    JSON.stringify(data) +
    '</script>');
  } else {
    itemHtml = itemHtml.replace(/{{quickAddForm}}/g, '');
  }

  return itemHtml;
};


/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Labels
  return soldOutLabel + saleLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);
      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};


// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};


// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  var windowPath = window.location.pathname;
  if(windowPath !== '/search') {
    setCollectionInfo(data[0].handle)
  }
};

function getCollectionsData(url, data) { 
  return _.filter(data, function (o) { return o.handle === url}) 
}

function updateCollectionInfo(currentCollection) {
  var collectionInfo = currentCollection[0];
  var $collectionHeader = $('h1');
  var $collectionDescription = $('.collection-hero__description');
  var $seo_text = $('.seo_text');
  $collectionHeader.html(collectionInfo.title);
  $collectionDescription.html(collectionInfo.description);
  $seo_text.html(collectionInfo.seo_text);
}

function setCollectionInfo(productHandle) {
  $.ajax({
    type: 'GET',
    url: '/search?type=collection&q=title:"' + productHandle + '"&view=filter',
    dataType: 'json',
    success: function(res){
      var collections = res.collections;
      var urlPathname = window.location.pathname.split('/collections/')[1];
      var currentCollection = getCollectionsData(urlPathname, collections);
      updateCollectionInfo(currentCollection)
      },
    error: function(error, status){       
        $('a[href$="gift-coffee-subscription"]').parent().find('div.btn--hollow, .grid-view-item__actions-separator').hide();

      console.error(status)
      console.log(error)
      }
    });
    }

// Make Selectric work with sort menu
function _sortDropdowns(_this) {
  $('[js-target=sorting-dropdown]').selectric();
  $('[name="quantity"]').selectric();

  $('[js-target=sorting-dropdown]').on('selectric-change', function(e, element) {
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, $(element).val());
  });
}

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
  var _this = this;
  var windowPath = window.location.pathname;

  _sortDropdowns(_this);
  theme.QuickAdd.init();

  $(document).ready(function() {
    var sections = new theme.Sections();
    sections.register('product', theme.Product);

    var count = $('[js-results-count] strong:first-child').text();
    $('[js-results-count]').text(count + ' items');
  });
  if(windowPath !== '/search') {
    $('[js-item-count]').html(setItemsCount(data.total_product));
  }
};

function setItemsCount(productCount) {
  var themeItemStrings = theme.strings.items;
  if (productCount === 1) {
    return themeItemStrings.one.replace('{{ count }}', productCount)
  } else {
    return themeItemStrings.other.replace('{{ count }}', productCount)
  }
}

    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
